// TODO: change any with real types
import {PolicyDataKey} from './Policy';

type CpeItem = {
  checks: {value: string; __href: string; __system: string}[];
  deprecated: boolean;
  name: string;
  title: string;
};

type CpeOval = {
  definitions: any[];
  objects: any[];
  states: any[];
  tests: any[];
  variables: any;
};

export type PolicyDetailsResponse = {
  benchmarkDescription: string;
  benchmarkId: string;
  benchmarkTitle: string;
  cpeList: {cpeItems: CpeItem[]};
  cpeOval: CpeOval;
  definitions: any[];
  groups: any[];
  objects: any[];
  platforms: {_idref: string}[];
  policyId: string;
  policyTitle: string;
  profileDescription: string;
  profileId: string;
  profileTitle: string;
  publisher: string;
  rules: any;
  replacedBy: string | null;
  replaces: string[] | null;
  states: any[];
  tests: any[];
  timestamp: number;
  values: any[];
  variables: any[];
  version: string;
  policyInternalId: string;
};

export type PolicyDetails = {
  [PolicyDataKey.VERSION]: string;
  [PolicyDataKey.ASSESSED_ASSETS]?: string;
  [PolicyDataKey.POLICY_PUBLISHER]?: string;
  [PolicyDataKey.ASSET_COMPLIANCE]?: string;
  [PolicyDataKey.RULE_COMPLIANCE]?: string;
  [PolicyDataKey.IS_ENABLED]?: boolean;
  [PolicyDataKey.IS_ASSESSED]?: boolean;
  [PolicyDataKey.IS_DEPRECATED]?: boolean;
  [PolicyDataKey.LAST_AGENT_POLICY_ASSESSMENT_TIME]?: number | null;
  benchmarkTitle: string;
  benchmarkId: string;
  profileDescription?: string;
  profileTitle: string;
  profileId: string;
  policyTitle: string;
  benchmarkDescription?: string;
  policyId: string;
  policyInternalId?: string;
  enabledPolicyId?: number;
  [PolicyDataKey.ASSET_SCOPE_QUERY_ID]?: string;
};

export enum PolicyDetailsTabViews {
  ASSETS = 'assets',
  RULES = 'rules',
  OVERRIDES = 'overrides',
}
